var _a;
import { translate } from './translations/i18n';
export var RESPONSE_TIME;
(function (RESPONSE_TIME) {
    RESPONSE_TIME["ASAP"] = "asap";
    RESPONSE_TIME["MINUTES"] = "minutes";
    RESPONSE_TIME["HOURS"] = "hours";
    RESPONSE_TIME["DAY"] = "day";
})(RESPONSE_TIME || (RESPONSE_TIME = {}));
var values = (_a = {},
    _a[RESPONSE_TIME.ASAP] = function () { return translate('response-time.asap'); },
    _a[RESPONSE_TIME.MINUTES] = function () { return translate('response-time.minutes'); },
    _a[RESPONSE_TIME.HOURS] = function () { return translate('response-time.hours'); },
    _a[RESPONSE_TIME.DAY] = function () { return translate('response-time.day'); },
    _a);
export var getValueFor = function (key) { return values[key](); };
export var options = Object.keys(values).map(function (key) { return ({
    key: key,
    get value() {
        return getValueFor(key);
    },
}); });
export var responseTime = {
    RESPONSE_TIME: RESPONSE_TIME,
    getValueFor: getValueFor,
    options: options,
};
//# sourceMappingURL=response-time.js.map